import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AAConstant } from 'src/app/core/models/constants';
import { SitecoreService } from 'src/app/core/services/sitecore-service/sitecore.service';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';

@Component({
  selector: 'app-merchandising',
  templateUrl: './merchandising.component.html',
  styleUrls: ['./merchandising.component.scss'],
  standalone: false
})
export class MerchandisingComponent implements AfterViewInit, OnDestroy {
  destroy$ = new Subject<void>();
  colourClass = 'bg-secondary';
  iconSrc: string;
  bodyText!: string;
  showBanner = false;
  iconAlt: string;
  blackBackground = 'aa-bg-black';
  linkLabel = '';
  bodyTextWithoutAnchorLabel = '';
  linkHref = '';

  @ViewChild('animatedBannerElement') private animatedBanner: ElementRef;
  @ViewChild('bannerContainer') private bannerContainer: ElementRef;

  constructor(private sitecoreService: SitecoreService, private renderer: Renderer2, private appService: AppService) {}

  ngAfterViewInit(): void {
    this.sitecoreService
      .getHeadlessContent()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (roadSalesMainObj) => {
          if (roadSalesMainObj?.componentName === AAConstant.PROMO_BANNER_COMPONENT_NAME && roadSalesMainObj?.fields) {
            this.showBanner = true;
            this.colourClass = `aa-${roadSalesMainObj.fields.BackgroundColor.fields.Value.value}`;
            this.iconSrc = `url(${roadSalesMainObj.fields.Icon.value.src}) no-repeat`;
            this.iconAlt = roadSalesMainObj.fields.Icon.value.alt;
            this.bodyText = roadSalesMainObj.fields.BodyText.value;
            sessionStorage.setItem('banner_closed', 'false');
          } else {
            this.destroyBannerContainer();
          }
        },
        () => {
          //  API error scenario
          this.destroyBannerContainer();
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCloseClick(): void {
    //  banner closed tracking
    this.appService.trackingAndSeoService.link({
      event_category: 'Route Planner',
      event_name: `click - ${this.bodyTextWithoutAnchorLabel}`,
      event_label: `Close - ${this.linkHref}`
    });
    this.renderer.addClass(this.animatedBanner.nativeElement, 'close-animation');
  }

  onAnimationEnd(): void {
    // close the banner on closing animation end
    this.showBanner = ![...this.animatedBanner.nativeElement.classList].includes('close-animation');
    if (!this.showBanner) {
      this.destroyBannerContainer();
      sessionStorage.setItem('banner_closed', 'true');
    } else {
      const anchorElement = this.animatedBanner.nativeElement.querySelector('a');
      const animatedBannerText = this.animatedBanner.nativeElement.textContent;
      // add event listener on intial animation
      this.renderer.listen(anchorElement, 'click', this.onBannerLinkClicked.bind(this));
      this.linkLabel = anchorElement?.innerText;
      this.linkHref = anchorElement?.pathname;
      this.bodyTextWithoutAnchorLabel = animatedBannerText?.substring(0, animatedBannerText?.indexOf(this.linkLabel));
    }
  }

  private destroyBannerContainer() {
    this.showBanner = false;
    this.renderer.removeChild(this.bannerContainer.nativeElement.parentElement, this.bannerContainer.nativeElement);
  }

  private onBannerLinkClicked(): void {
    // link clicked tracking
    this.appService.trackingAndSeoService.link({
      event_category: 'Route Planner',
      event_name: `click - ${this.bodyTextWithoutAnchorLabel}`,
      event_label: `${this.linkLabel} - ${this.linkHref}`
    });
  }
}
